import { Button, Radio, Wrap, WrapItem, RadioGroup } from '@chakra-ui/react'
import { Choice, Field, RadioTypeDef } from '@micin-jp/chicken-schema'

import { useWorksheetValueContext } from '../../context/WorksheetValue'
import { getErrorMessage } from '../../utils/getErrorMessage'
import { WorksheetFieldFormControl } from '../WorksheetFieldFormControl/WorksheetFieldFormControl'

type Props = {
  radioField: Field & {
    typeDef: RadioTypeDef
  }
  index: number
}

export const WorksheetRadioField: React.FC<Props> = ({ radioField, index }) => {
  const {
    findFieldValue,
    onChangeRadioFieldValue,
    canEdit,
    isRepeatableSectionEnabled,
  } = useWorksheetValueContext()

  const value = findFieldValue({
    fid: radioField.fid,
    index,
  })

  const onChange = (radioValue: Choice['cid'] | undefined) => {
    onChangeRadioFieldValue({
      fid: radioField.fid,
      index,
      radioValue,
    })
  }

  const isDisabled =
    !canEdit(radioField.typeDef) ||
    !isRepeatableSectionEnabled(index, radioField.fid)

  return (
    <WorksheetFieldFormControl
      field={radioField}
      index={index}
      isDisabled={isDisabled}
      errorMessage={getErrorMessage(value)}
    >
      <RadioGroup
        value={value?.type === 'radio' ? value.radioValue : ''}
        onChange={selectedCid => {
          onChange(selectedCid || undefined)
        }}
        isDisabled={isDisabled}
      >
        <Wrap spacing="8">
          {radioField.typeDef.choices.map(choice => (
            <WrapItem key={choice.cid} alignItems="center">
              <Radio value={choice.cid}>{choice.name}</Radio>
            </WrapItem>
          ))}
          {!isDisabled && (
            <WrapItem>
              <Button variant="text" onClick={() => onChange(undefined)}>
                選択クリア
              </Button>
            </WrapItem>
          )}
        </Wrap>
      </RadioGroup>
    </WorksheetFieldFormControl>
  )
}
